import styled from 'styled-components';
import { media, layout } from 'src/components/base';
import { Column } from '@prisjakt/ui/list/variants';

export const ColumnWithGutter = styled(Column)`
  padding-left: ${layout.measurements.spacing050};
  padding-right: ${layout.measurements.spacing050};
`;

export const CampaignGraphic = styled.img`
  display: block;
  width: 300px;

  ${media.smallOnly`
    width: 100%;
  `}
`;
